<div *ngIf="message" [innerHtml]="message | safeHtml"></div>